import TablaBonifFletes from "./TablaBonifFletes";

export default TablaBonifFletes;
